<template>
  <div>
    <footer>
      <div class="container">
        <div class="row row-1">
          <div class="col-md-12">
            <img src="@/assets/img/logo.svg" width="38" />
          </div>
        </div>
        <div class="row row-2">
          <div class="col-md-6 footer-1">
            <h3>
              A collaborative site for the arts
              community to create their own stages globally.
            </h3>
            <ul class="list-inline">
              <li>
                <a href="https://www.instagram.com/cardboard.stage/?igshid=14fb4811umf0c" target="_blank">
                  <img src="@/assets/img/media/instagram.png" />
                </a>
              </li>
              <!--<li>-->
              <!--<a href="#">-->
              <!--<img src="@/assets/img/media/facebook.png" />-->
              <!--</a>-->
              <!--</li>-->
            </ul>
          </div>
          <div class="col-md-3 footer-2">
            <ul class="list-unstyled">
              <li>
                <a href="#" class="active">
                  Community
                </a>
              </li>
              <li>
                <router-link to="/artists/">Artists</router-link>
              </li>
              <li>
                <router-link to="/stages">Stages</router-link>
              </li>
              <li>
                <router-link to="/stage/create/">Create a Stage</router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-3 footer-3">
            <ul class="list-unstyled">
              <li>
                <router-link class="active" to="/about/">About Us</router-link>
              </li>
              <li>
                <router-link to="/contact/">Contact</router-link>
              </li>
              <!--<li>-->
              <!--<router-link to="/about/">Our Team</router-link>-->
              <!--</li>-->
              <!--<li>-->
              <!--<router-link to="/press/">Press</router-link>-->
              <!--</li>-->
              <li>
                <router-link to="/events/upcoming/">Upcoming Events</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row row-3">
          <div class="col-md-12">
            <p>© 2021 Cardboard Stage. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    import $ from "jquery"
    import Chat from "./include/Chat";
    import ChatStageGroup from "./include/ChatStageGroup";
export default {
  name: 'Footer',
    data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
    mounted(){
        $('body').removeClass('modal-open')
        $('.modal-backdrop').detach()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue